import { VZTC_URL } from '../../constants/constants';
export const Chat = function(){
  // To initiate chat
  const script = document.createElement("script");
  script.src = VZTC_URL;
  script.async = true;
  document.body.appendChild(script);
  
  if(window.location.href.indexOf('homeoneapp')> -1) {
    window.disableonloadAsappChatIcon = true
  } 
 
  if((window.location.href.indexOf('contactus') < 0) && !(window.location.href.indexOf('homeoneapp')> -1)) {
    window.chat_vendor= 'a';
  }
  
  if(window.location.href.indexOf('contactus')> -1) {
    if((window.location.href.indexOf('src=FioSTroubleshooting')> -1)||(window.location.href.indexOf('src=fiostroubleshooting')> -1)) {
      console.log("include chat Query Parameter");
      window.chat_vendor= 'a';
      window.disableonloadAsappChatIcon = false;
    }
    else{
        window.disableonloadAsappChatIcon = true
    }
  }
 
  if(window.oneAppFlag == true && window.oneAppFlag != null){
    if(window.location.href.indexOf('home')> -1 || window.location.href.indexOf('internet')> -1 || window.location.href.indexOf('tv')> -1 || window.location.href.indexOf('homephone')> -1 || window.location.href.indexOf('account')> -1 || window.location.href.indexOf('serviceoutage')> -1 || window.location.href.indexOf('battery-backup')> -1 || window.location.href.indexOf('battery-equipment-return')> -1 || window.location.href.indexOf('paymentlocations')> -1 || window.location.href.indexOf('equipment-return')> -1 || window.location.href.indexOf('contact-us')> -1 ){
    window.disableonloadAsappChatIcon = true
    }
  }
  //VZWYZCT-428//fiostroubleshooting
  if((window.location.href.indexOf('src=FioSTroubleshooting')> -1)||(window.location.href.indexOf('src=fiostroubleshooting')> -1)) {
    console.log("include chat Query Parameter");
    setTimeout(() => {
      console.log("Include chat - timer");
      try{
        
          // window.initiateChat();
          window.EchannelVera.init({});
      }catch(e){console.log("Include chat error :" +e);}
      console.log("Include chat - end");
  }, 1500);
}
 

}




// WEBPACK FOOTER //
// ./src/components/modules/IncludeChat.js